import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";

const useRetornarTextoPadrao = () => {
  const [textoPadrao, setTextoPadrao] = useState("");
  const { request, data, errors, isLoading } = useApiClient();

  useEffect(() => {
    const parametros = {
      Sigla: "PEDPROROS",
      pageSize: 1,
      pageNumber: 1,
    };

    request(apiRoutes.fiscalizacao.parametrizacao.buscaAtividadePadrao, parametros);
  }, [request]);

  useEffect(() => {
    if (!data && !errors) return;

    if (data.result.length > 0) {
      setTextoPadrao(data.result[0].textoDocumento);
    }

    if (errors) {
      toast.error(errors.message);
    }
  }, [data, errors]);

  return { textoPadrao, isLoading };
};

export default useRetornarTextoPadrao;
